/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { XHR } from './XHR'
import { CalendarItem } from '../model/CalendarItem'
import { DocIdentifier } from '../model/DocIdentifier'
import { IcureStub } from '../model/IcureStub'
import { ListOfIds } from '../model/ListOfIds'
import { AuthenticationProvider, NoAuthenticationProvider } from '../../icc-x-api/auth/AuthenticationProvider'
import { iccRestApiPath } from './IccRestApiPath'
import { EntityShareOrMetadataUpdateRequest } from '../model/requests/EntityShareOrMetadataUpdateRequest'
import { EntityBulkShareResult } from '../model/requests/EntityBulkShareResult'
import { MinimalEntityBulkShareResult } from '../model/requests/MinimalEntityBulkShareResult'
import { BulkShareOrUpdateMetadataParams } from '../model/requests/BulkShareOrUpdateMetadataParams'
import { PaginatedListCalendarItem } from '../model/PaginatedListCalendarItem'

export class IccCalendarItemApi {
  host: string
  _headers: Array<XHR.Header>
  authenticationProvider: AuthenticationProvider
  fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>

  get headers(): Promise<Array<XHR.Header>> {
    return Promise.resolve(this._headers)
  }

  constructor(
    host: string,
    headers: any,
    authenticationProvider?: AuthenticationProvider,
    fetchImpl?: (input: RequestInfo, init?: RequestInit) => Promise<Response>
  ) {
    this.host = iccRestApiPath(host)
    this._headers = Object.keys(headers).map((k) => new XHR.Header(k, headers[k]))
    this.authenticationProvider = !!authenticationProvider ? authenticationProvider : new NoAuthenticationProvider()
    this.fetchImpl = fetchImpl
  }

  setHeaders(h: Array<XHR.Header>) {
    this._headers = h
  }

  handleError(e: XHR.XHRError): never {
    throw e
  }

  /**
   *
   * @summary Creates a calendarItem
   * @param body
   */
  async createCalendarItem(body?: CalendarItem): Promise<CalendarItem> {
    const _url = this.host + `/calendarItem` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new CalendarItem(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * @summary Deletes a calendarItem by id.
   *
   * @summary Deletes an calendarItem
   * @param calendarItemId the id of calendarItem to delete.
   * @return a Promise that will resolve in the DocIdentifier of the deleted calendarItem.
   */
  async deleteCalendarItem(calendarItemId: string): Promise<DocIdentifier> {
    return XHR.sendCommand(
      'DELETE',
      this.host + `/calendarItem/${encodeURIComponent(calendarItemId)}` + '?ts=' + new Date().getTime(),
      await this.headers,
      null,
      this.fetchImpl,
      undefined,
      this.authenticationProvider.getAuthService()
    )
      .then((doc) => new DocIdentifier(doc.body))
      .catch((err) => this.handleError(err))
  }

  /**
   * @summary Deletes a batch of calendarItems by id.
   *
   * @summary Deletes calendarItems
   * @param body a ListOfIds containing the ids of the calendarItems to delete.
   * @return a Promise that will resolve in an array of DocIdentifiers of the successfully deleted calendarItems.
   */
  async deleteCalendarItems(body?: ListOfIds): Promise<Array<DocIdentifier>> {
    const headers = (await this.headers).filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand(
      'POST',
      this.host + `/calendarItem/delete/batch` + '?ts=' + new Date().getTime(),
      headers,
      body,
      this.fetchImpl,
      undefined,
      this.authenticationProvider.getAuthService()
    )
      .then((doc) => (doc.body as Array<JSON>).map((it) => new DocIdentifier(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * @deprecated use {@link findCalendarItemIdsByDataOwnerPatientStartTime} instead.
   * @summary Find CalendarItems by hcparty and patient
   * @param body
   * @param hcPartyId
   */
  async findCalendarItemsByHCPartyPatientForeignKeysUsingPost(hcPartyId: string, body?: Array<string>): Promise<Array<CalendarItem>> {
    const _url =
      this.host +
      `/calendarItem/byHcPartySecretForeignKeys` +
      '?ts=' +
      new Date().getTime() +
      (hcPartyId ? '&hcPartyId=' + encodeURIComponent(String(hcPartyId)) : '')
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new CalendarItem(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * @deprecated use {@link findCalendarItemIdsByDataOwnerPatientStartTime} instead.
   * @summary Find CalendarItems by hcparty and patient
   * @param hcPartyId
   * @param secretFKeys
   */
  async findCalendarItemsByHCPartyPatientForeignKeys(hcPartyId: string, secretFKeys: string): Promise<Array<CalendarItem>> {
    let _body = null

    const _url =
      this.host +
      `/calendarItem/byHcPartySecretForeignKeys` +
      '?ts=' +
      new Date().getTime() +
      (hcPartyId ? '&hcPartyId=' + encodeURIComponent(String(hcPartyId)) : '') +
      (secretFKeys ? '&secretFKeys=' + encodeURIComponent(String(secretFKeys)) : '')
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new CalendarItem(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   * @deprecated use {@link findCalendarItemsByRecurrenceIdWithPagination} instead.
   *
   * @summary Find CalendarItems by recurrenceId
   * @param recurrenceId
   */
  async findCalendarItemsByRecurrenceId(recurrenceId: string): Promise<Array<CalendarItem>> {
    const _url = this.host + `/calendarItem/byRecurrenceId?ts=${new Date().getTime()}&recurrenceId=${encodeURIComponent(recurrenceId)}&limit=1000000`
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new PaginatedListCalendarItem(doc.body as JSON).rows ?? [])
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Find CalendarItems by recurrenceId
   * @param recurrenceId the recurrence id.
   * @param startKey the startKey provided by the previous page or undefined for the first page.
   * @param startDocumentId the startDocumentId provided by the previous page or undefined for the first page.
   * @param limit the number of elements that the page should contain.
   * @return a promise that will resolve in a PaginatedListAccessLog.
   */
  async findCalendarItemsByRecurrenceIdWithPagination(
    recurrenceId: string,
    startKey?: string,
    startDocumentId?: string,
    limit?: number
  ): Promise<PaginatedListCalendarItem> {
    const _url =
      this.host +
      `/calendarItem/byRecurrenceId?ts=${new Date().getTime()}&recurrenceId=${encodeURIComponent(recurrenceId)}` +
      (!!startKey ? `&startKey=${encodeURIComponent(startKey)}` : '') +
      (!!startDocumentId ? `&startDocumentId=${encodeURIComponent(startDocumentId)}` : '') +
      (!!limit ? `&limit=${limit}` : '')
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new PaginatedListCalendarItem(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Gets a calendarItem
   * @param calendarItemId
   */
  async getCalendarItem(calendarItemId: string): Promise<CalendarItem> {
    let _body = null

    const _url = this.host + `/calendarItem/${encodeURIComponent(String(calendarItemId))}` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new CalendarItem(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * @deprecated use {@link getCalendarItemsWithPagination} instead
   *
   * @summary Gets all calendarItems
   */
  async getCalendarItems(): Promise<Array<CalendarItem>> {
    const _url = this.host + `/calendarItem?ts=${new Date().getTime()}$limit=1000000`
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new PaginatedListCalendarItem(doc.body as JSON).rows ?? [])
      .catch((err) => this.handleError(err))
  }

  /**
   * @summary gets all Calendar Items with pagination.
   *
   * @param startDocumentId the startDocumentId provided by the previous page or null if it's the first page.
   * @param limit the size of the page
   * @return a promise that will resolve in a PaginatedListCalendarItem.
   */
  async getCalendarItemsWithPagination(startDocumentId?: string, limit?: number): Promise<PaginatedListCalendarItem> {
    const _url =
      this.host +
      `/calendarItem` +
      '?ts=' +
      new Date().getTime() +
      (!!startDocumentId ? `&startDocumentId=${encodeURIComponent(startDocumentId)}` : '') +
      (!!limit ? `&limit=${limit}` : '')
    let headers = await this.headers
    return XHR.sendCommand('GET', _url, headers, null, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new PaginatedListCalendarItem(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Get CalendarItems by Period and HcPartyId
   * @param startDate
   * @param endDate
   * @param hcPartyId
   */
  async getCalendarItemsByPeriodAndHcPartyId(startDate: number, endDate: number, hcPartyId: string): Promise<Array<CalendarItem>> {
    let _body = null

    const _url =
      this.host +
      `/calendarItem/byPeriodAndHcPartyId` +
      '?ts=' +
      new Date().getTime() +
      (startDate ? '&startDate=' + encodeURIComponent(String(startDate)) : '') +
      (endDate ? '&endDate=' + encodeURIComponent(String(endDate)) : '') +
      (hcPartyId ? '&hcPartyId=' + encodeURIComponent(String(hcPartyId)) : '')
    let headers = await this.headers
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new CalendarItem(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Get calendarItems by id
   * @param body
   */
  async getCalendarItemsWithIds(body?: ListOfIds): Promise<Array<CalendarItem>> {
    const _url = this.host + `/calendarItem/byIds` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new CalendarItem(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Get CalendarItems by Period and AgendaId
   * @param startDate
   * @param endDate
   * @param agendaId
   */
  async getCalendarsByPeriodAndAgendaId(startDate: number, endDate: number, agendaId: string): Promise<Array<CalendarItem>> {
    let _body = null

    const _url =
      this.host +
      `/calendarItem/byPeriodAndAgendaId` +
      '?ts=' +
      new Date().getTime() +
      (startDate ? '&startDate=' + encodeURIComponent(String(startDate)) : '') +
      (endDate ? '&endDate=' + encodeURIComponent(String(endDate)) : '') +
      (agendaId ? '&agendaId=' + encodeURIComponent(String(agendaId)) : '')
    let headers = await this.headers
    return XHR.sendCommand('POST', _url, headers, _body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => new CalendarItem(it)))
      .catch((err) => this.handleError(err))
  }

  /**
   *
   * @summary Modifies an calendarItem
   * @param body
   */
  async modifyCalendarItem(body?: CalendarItem): Promise<CalendarItem> {
    const _url = this.host + `/calendarItem` + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => new CalendarItem(doc.body as JSON))
      .catch((err) => this.handleError(err))
  }

  /**
   * @internal this method is for internal use only and may be changed without notice
   */
  async bulkShareCalendarItems(request: BulkShareOrUpdateMetadataParams): Promise<EntityBulkShareResult<CalendarItem>[]> {
    const _url = this.host + '/calendarItem/bulkSharedMetadataUpdate' + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, request, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((x) => new EntityBulkShareResult<CalendarItem>(x, CalendarItem)))
      .catch((err) => this.handleError(err))
  }

  /**
   * @internal this method is for internal use only and may be changed without notice
   */
  async bulkShareCalendarItemsMinimal(request: BulkShareOrUpdateMetadataParams): Promise<MinimalEntityBulkShareResult[]> {
    const _url = this.host + '/calendarItem/bulkSharedMetadataUpdateMinimal' + '?ts=' + new Date().getTime()
    let headers = await this.headers
    headers = headers.filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    return XHR.sendCommand('PUT', _url, headers, request, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((x) => new MinimalEntityBulkShareResult(x)))
      .catch((err) => this.handleError(err))
  }

  /**
   * @summary List CalendarItem ids by data owner and a set of secret foreign key. The ids will be sorted by CalendarItem startTime, in ascending or descending
   * order according to the specified parameter value.
   *
   * @param dataOwnerId the data owner id.
   * @param secretFKeys an array of secret foreign keys.
   * @param startDate a timestamp in epoch milliseconds. If undefined, all the calendar item ids since the beginning of time will be returned.
   * @param endDate a timestamp in epoch milliseconds. If undefined, all the calendar item ids until the end of time will be returned.
   * @param descending whether to return the ids ordered in ascending or descending order by CalendarItem startTime
   * @return a promise that will resolve in an Array of CalendarItem ids.
   */
  async findCalendarItemIdsByDataOwnerPatientStartTime(
    dataOwnerId: string,
    secretFKeys: string[],
    startDate?: number,
    endDate?: number,
    descending?: boolean
  ): Promise<string[]> {
    const _url =
      this.host +
      `/calendarItem/byDataOwnerPatientStartTime?ts=${new Date().getTime()}` +
      '&dataOwnerId=' +
      encodeURIComponent(dataOwnerId) +
      (!!startDate ? `&startDate=${encodeURIComponent(startDate)}` : '') +
      (!!endDate ? `&endDate=${encodeURIComponent(endDate)}` : '') +
      (!!descending ? `&descending=${descending}` : '')
    const headers = (await this.headers).filter((h) => h.header !== 'Content-Type').concat(new XHR.Header('Content-Type', 'application/json'))
    const body = new ListOfIds({ ids: secretFKeys })
    return XHR.sendCommand('POST', _url, headers, body, this.fetchImpl, undefined, this.authenticationProvider.getAuthService())
      .then((doc) => (doc.body as Array<JSON>).map((it) => JSON.parse(JSON.stringify(it))))
      .catch((err) => this.handleError(err))
  }
}
